import React from 'react'
import classNames from 'classnames'
import conf from 'conf'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { timeFormat } from 'utils'
import { SERVICE_LOGO_IMAGE, SERVICE_COPYRIGHT, SETTING_SERVICE_LOGO_IMAGE } from 'service'
import PLAN_TYPE from 'types/utils'
import aboutLogoIcon1 from '@/assets/images/logo/icon-about-logo.svg'
import styles from '../style.module.scss'

const AboutRender = () => {
  const { t } = useTranslation()
  const user = useSelector((state) => state.user)
  const { paidLicense } = user

  const formatDateRange = () => {
    if (!paidLicense?.started_at || !paidLicense?.expires_at) {
      return null
    }

    const startDate = timeFormat(paidLicense.started_at, 'MMM D, YYYY')
    const endDate = timeFormat(paidLicense.expires_at, 'MMM D, YYYY')
    return `${startDate} - ${endDate}`
  }

  const dateRange = formatDateRange()

  const getLicenseLabel = () => {
    if (!paidLicense) return null

    const planType = paidLicense.plan_type
    if (planType === PLAN_TYPE.TRIAL) {
      return t('appConfig.settings.trialLicense')
    }
    return t('appConfig.settings.paidLicense')
  }

  const licenseLabel = getLicenseLabel()

  return (
    <div className={classNames(styles.aboutContent)}>
      <img src={aboutLogoIcon1} alt={SERVICE_LOGO_IMAGE} className={classNames(styles.logo)} />
      <div className={classNames(styles.versionInfo)}>
        <img src={SETTING_SERVICE_LOGO_IMAGE} alt="logo" className={classNames(styles.logoText)} />
        <span>Version {conf.packageInfo.version}</span>
      </div>
      {paidLicense && licenseLabel && (
        <div className={classNames(styles.paidLicense)}>
          <span>{licenseLabel}</span>
          {dateRange && <span>{dateRange}</span>}
        </div>
      )}
      <span>{SERVICE_COPYRIGHT}</span>
    </div>
  )
}

export default AboutRender
